import React from "react";
import { graphql } from "gatsby";
import { FeaturedAccount as FeaturedAccountComponent } from "@zempler/theme/src/components/featuredAccount/FeaturedAccount";

export const FeaturedAccount = ({ data, ...rest }) => {
  return (
    <FeaturedAccountComponent
      {...data}
      featuredImage={data.image?.image?.localFile}
      mobileImage={data.mobileImage?.image?.localFile}
    />
  );
};

export const FeaturedAccountQuery = graphql`
  fragment FeaturedAccount on UMBRACO_FeaturedAccountComponentType {
    name: accountName
    subHeading
    secondarySubheading
    monthlyCost
    details {
      detail
      heading
    }
    benefits {
      detail
      heading
      included
    }
    image {
      image {
        ...AccountImage
      }
    }
    accountFeeHeading
    accountFeeSubHeading
    fees {
      detail
      extraDetail
      heading
    }
    colour
    mobileImage {
      image {
        ...MobileAccountImage
      }
    }
    limits {
      detail: description
      heading
    }
    buttonColour
    feeSmallPrint
    allFeesLink {
      ...Link
    }
    primaryButton {
      ...Link
    }
    secondaryLink {
      ...Link
    }
    hideArrowFees
    hideArrowPrimary
    hideArrowSecondary
  }
`;
